const BACKEND_RATES_URL = `${process.env.REACT_APP_SERVER_URL}/api/exchange-rates`

const DEFAULT_RATES = {
    NGN: 1, USD: 1580, EUR: 1717, GBP: 1994, JPY: 10.5,
    CAD: 1160, AUD: 1030, INR: 19, CNY: 228, BRL: 322,
    ZAR: 85, KES: 12, MXN: 92, SAR: 421
}

const SYMBOLS = {
    NGN: '₦', USD: '$', EUR: '€', GBP: '£', JPY: '¥',
    CAD: 'CA$', AUD: 'A$', INR: '₹', CNY: '¥', BRL: 'R$',
    ZAR: 'R', KES: 'KSh', MXN: 'Mex$', SAR: '﷼'
}

export const SUPPORTED_CURRENCIES = Object.keys(DEFAULT_RATES)

let exchangeRates = { ...DEFAULT_RATES }

export const fetchExchangeRates = async () => {
    try {
        const res = await fetch(BACKEND_RATES_URL)
        const data = await res.json()
        if (data && data.rates) {
            exchangeRates = { ...DEFAULT_RATES, ...data.rates }
        }
    } catch (error) {
        console.error('Error fetching exchange rates:', error)
    }
}

/**
 * Convert and format a value stored in USD to the target currency.
 * Prices are stored in USD; rates are NGN-base (NGN per 1 unit of currency).
 * Formula: value_usd * (rates[USD] / rates[targetCurrency])
 *   e.g. $200 → NGN: 200 * (1580/1) = 316,000 ₦
 *        $200 → EUR: 200 * (1580/1717) ≈ 184 €
 */
export const formatCurrency = (value, currencyCode) => {
    const code = currencyCode || 'NGN'
    const usdRate = exchangeRates['USD'] ?? 1580
    const targetRate = exchangeRates[code] ?? 1
    const converted = value * (usdRate / targetRate)
    const symbol = SYMBOLS[code] ?? code
    const fractionDigits = converted < 1 ? 2 : 0
    return `${symbol} ${converted.toLocaleString(undefined, { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits })}`
}

export const getCurrencySymbol = (currencyCode) => SYMBOLS[currencyCode] ?? currencyCode

export const getExchangeRates = () => ({ ...exchangeRates })
